import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnChanges,
  SimpleChanges,
  input,
  output,
} from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-saved-view-create',
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './saved-view-create.component.html',
  styleUrls: ['./saved-view-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SavedViewCreateDialogComponent implements OnChanges {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  name = '';
  isDuplicate = false;

  existingNames = input<string[]>([]);
  initialName = input<string | undefined>();
  title = input<string | undefined>();

  close = output<string | null>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialName) {
      this.name = String(changes.initialName.currentValue ?? '');
    }
    if (changes.initialName || changes.existingNames) {
      this.onNameChange();
    }
  }

  onNameChange(): void {
    const trimmed = this.name.trim().toLowerCase();
    const existingNames = this.existingNames();

    if (!trimmed || !existingNames?.length) {
      this.isDuplicate = false;
      return;
    }

    this.isDuplicate = existingNames.some((n) => n.trim().toLowerCase() === trimmed);
  }

  canSave(): boolean {
    return this.name.trim().length > 0 && !this.isDuplicate;
  }

  onCancel(): void {
    this.close.emit(null);
  }

  onSave(): void {
    if (!this.canSave()) {
      return;
    }

    this.close.emit(this.name.trim());
  }
}
